import elementLocale from 'element-ui/lib/locale/lang/en'

export default {
  floorplanEvaluation: {
    entry: "Floorplan evaluation",
    aiResultOnly: "Evaluation uses this project's latest successful AI architectural design result. Editor changes are excluded, whether saved or not.",
    running: "Evaluating floorplan / loading results",
    previousVersion: "This report is for an earlier AI architectural design result, or its version cannot be confirmed.",
    total: "Total score",
    normalized: "Normalized score",
    objective: "Objective score",
    subjective: "Subjective score",
    details: "Evaluation details",
    empty: "No completed evaluation",
    refresh: "Refresh results",
    start: "Start evaluation",
    failed: "Floorplan evaluation failed. Please retry.",
    OBJ_01: "Room types and counts",
    OBJ_03: "MyBox dimension compliance",
    OBJ_06: "Stair alignment between floors",
    OBJ_07: "Major room exterior-wall contact potential",
    functional_zoning: "Functional zoning",
    circulation_organization: "Circulation",
    privacy: "Privacy",
    spatial_comfort: "Spatial comfort"
  },
  common: {
    appName: 'MH House',
    home: 'Home',
    login: 'Login',
    workspace: 'Workspace',
    logout: 'Log out',
    notFound: 'Page not found',
    backHome: 'Back home',
    cancel: 'Cancel',
    confirm: 'Confirm',
    apply: 'Apply',
    close: 'Close',
    all: 'All',
    user: 'User',
    updated: 'Updated',
    project: 'Project'
  },
  nav: {
    wallet: 'Wallet',
    changePassword: 'Change password',
    titles: {
      projectsStructure: 'Structure Projects',
      houseDesign: 'Project Details',
      architecturePlan: 'Architecture Plan',
      structureDesign: 'Structure Design',
      structureCalculation: 'Structure Calculation',
      designReport: 'Design Report'
    }
  },
  home: {
    title: 'MH House WebUI',
    subtitle: 'A clean frontend scaffold ready for the new project.',
    openWorkspace: 'Open workspace'
  },
  login: {
    title: 'Sign in',
    username: 'Username',
    password: 'Password',
    submit: 'Sign in',
    placeholder: 'Login endpoint placeholder. Replace it when the backend contract is ready.'
  },
  workspace: {
    title: 'Workspace',
    subtitle: 'Protected route placeholder.'
  },
  projects: {
    searchPlaceholder: 'Search project title',
    empty: 'No projects yet',
    fetchFailed: 'Failed to load projects',
    missingIdempotencyKey: 'Project is missing idempotency key',
    projectFallback: 'Project {id}',
    newProject: 'New project',
    createDialogTitle: 'New project',
    createDialogPlaceholder: 'Enter project name',
    createNameRequired: 'Project name is required',
    createFailed: 'Failed to create project',
    createConfirm: 'Create',
    manageProjects: 'Manage projects',
    exitManage: 'Exit management',
    deleteSelected: 'Delete ({count})',
    deleteConfirmTitle: 'Delete projects',
    deleteConfirmMessage: 'Delete the {count} selected project(s)? This action cannot be undone.',
    deleteConfirmButton: 'Delete',
    deleteSuccess: 'Deleted {count} project(s)',
    deleteFailed: 'Failed to delete projects'
  },
  houseDesign: {
    backToProjects: 'Back to projects',
    pageTitle: 'Project details',
    pageTitleWithKey: 'Project details - {key}',
    idempotencyKey: 'Idempotency key: {key}',
    missingKey: 'Missing project idempotency key. Please enter from the project list.',
    progressTitle: 'Project progress',
    enterStepTitle: 'Enter step',
    enterStep: 'Enter {step}',
    stepStatus: {
      completed: 'Completed',
      current: 'Current step',
      pending: 'Pending'
    },
    steps: {
      architecturePlan: 'Architecture plan',
      structureDesign: 'Structure design',
      structureCalculation: 'Structure calculation',
      designReport: 'Design report'
    }
  },
  constraints: {
    back: 'Back to project',
    title: 'Tell us your budget and frontage',
    budget: {
      title: 'Budget'
    },
    frontage: {
      title: 'Frontage',
      meters: 'approx. {meters} m'
    },
    recommendFailed: 'Product recommendations are temporarily unavailable. Please try again.',
    next: 'Next'
  },
  structureDesign: {
    generating: 'Generating...',
    back: 'Back',
    title: 'Detached House AI Design',
    subtitle: 'Design editor · {name}',
    undo: 'Undo',
    redo: 'Redo',
    save: 'Save',
    saveToStorage: 'Save',
    exportToFile: 'Export to file',
    exportProjectJson: 'Export project JSON',
    exportCadJson: 'Export CAD JSON',
    cadExport: {
      warningTitle: 'CAD handoff validation warnings',
      warningMessage: 'The CAD JSON contains validation warnings. You may still download it, but the handoff is not fully verified.',
      continue: 'Export anyway',
      fatal: 'The plan has invalid CAD geometry and cannot be exported.',
      failed: 'CAD JSON export failed. Please try again.',
      exported: 'CAD JSON exported: {fileName}',
      annotationsSaveFailed: 'Dimension annotations were exported but could not be saved to this project.',
      issueCategories: {
        geometry: 'Geometry validation warning ({code})',
        annotations: 'Annotation validation warning ({code})',
        structure: 'AI structure validation warning ({code})'
      }
    },
    load: 'Load',
    project: 'Project',
    tools: 'Tools',
    select: 'Select',
    sampleRoom: 'Sample room',
    catalog: 'Catalog',
    searchCatalog: 'Search catalog',
    designAssetRoomFilter: 'Room',
    designAssetStyleFilter: 'Style',
    designAssetRooms: {
      kitchen: 'Kitchen',
      bathroom: 'Bathroom',
      washroom: 'Washroom',
      outdoor: 'Outdoor',
      'living-dining': 'Living / Dining',
      'master-bedroom': 'Master bedroom',
      'kids-room': 'Kids room'
    },
    designAssetStyles: {
      'white-model': 'White model',
      natural: 'Natural',
      'simple-modern': 'Simple modern',
      japandi: 'Japandi',
      vintage: 'Vintage'
    },
    catalogFilterEmpty: 'No matching assets found',
    catalogFilterClear: 'Clear filters',
    catalogFilterLoading: 'Filtering…',
    catalogFilterBack: 'Back to categories',
    catalogFilterToggle: 'Toggle filters',
    properties: 'Properties',
    settings: 'Settings',
    projectConfiguration: 'Project configuration',
    aiDesign: 'AI design parameters',
    generate: 'Generate design',
    view2d: '2D view',
    view3d: '3D view',
    switchTo3d: 'Click to show 3D in the main view',
    switchTo2d: 'Click to show 2D in the main view',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    fitView: 'Fit to canvas',
    openCatalog: 'Open catalog',
    export: 'Export',
    exportChooseFormat: 'Choose export format',
    import: 'Import',
    developing: 'In development',
    catalogTitle: 'Element catalog',
    catalogHint: 'Select an element, then click on the 2D canvas to place it',
    catalogAvailable: '{count} elements available',
    catalogEmptyTitle: 'No matching elements',
    catalogEmptyHint: 'Try another category or search keyword',
    catalogFooter: 'Catalog / {category}',
    clearSearch: 'Clear search',
    inspectorDeveloping: 'This section is under development',
    selectionSummary: '{count} elements selected',
    emptyState: 'Select an element or choose a catalog item, then edit on the canvas.',
    editorToolbar: {
      label: 'Editor commands',
      file: 'File',
      clear: 'Clear',
      ai: 'AI',
      pdf: 'Export PDF',
      html: 'Export HTML',
      share: 'Share',
      clearConfirmTitle: 'Clear plan',
      clearConfirmMessage: 'This will clear the current plan. Continue?',
      placeholderNotice: 'This command will be wired in a later module. Placeholder only.'
    },
    clearScene: {
      success: 'Plan cleared successfully',
      failed: 'Failed to clear plan. Please try again.'
    },
    drawingUnderlay: {
      title: 'Underlay',
      show: 'Show underlay',
      hide: 'Hide underlay',
      opacity: 'Underlay opacity',
      elementOpacity: 'Element opacity'
    },
    viewSettings: {
      title: '3D view settings',
      daylight: 'Daylight',
      daylightSlider: 'Time of day',
      presets: {
        morning: 'Morning',
        midday: 'Midday',
        evening: 'Evening',
        night: 'Night'
      },
      ceilingHeight: 'Ceiling height',
      sectionCut: 'Section cut',
      sectionCutHint: 'Hides everything above the section height.'
    },
    editorToolGroups: {
      draw: 'Rooms / walls',
      openings: 'Doors / windows',
      structure: 'Structure',
      furnishings: 'Furnishings'
    },
    editorToolPanels: {
      drawHouse: 'Floor plan',
      layout: 'Furniture & materials'
    },
    camera: {
      tool: "Camera",
      renderTool: "Rendering",
      renderTitle: "Rendering",
      renderRecaptureHint: "Capture again from the current camera position",
      previewTitle: "Camera {index} · 3D view",
      openComposition: "Adjust framing",
      previewHint: "Click to adjust the framing",
      placingHint: "Click on the floor plan to place the camera",
      addOverhead: "3D overhead",
      addOverheadHint: "Add a camera that looks down on the building",
      overheadBadge: "Overhead",
      overheadHint: "Looks down on the selected floor from above.",
      compositionFromPreview: "Adjust the framing in the 3D view at the top right.",
      place: "Place camera",
      panelTitle: "Cameras",
      empty: "No cameras yet. Place one on the plan",
      limitReached: "Up to {max} cameras",
      item: "Camera {index}",
      position: "Position",
      elevation: "Height",
      yaw: "Heading",
      pitch: "Pitch",
      fov: "Field of view",
      remove: "Delete camera",
      enterComposition: "Open 3D framing",
      clampedTo: "Clamped to {value}",
      readonlyHint: "Project is read-only; cameras cannot be edited",
      lockedWhileRendering: "Rendering in progress. Cameras cannot be edited.",
      compositionTitle: "3D framing · Camera {index}",
      compositionDone: "Done",
      compositionCancel: "Cancel",
      compositionHint: "Drag to orbit, scroll to zoom. The frame is exactly what gets rendered.",
      compositionAspect: "16:9 (matches output ratio)",
      compositionDegraded: "Window too small; the framing box is shown scaled down",
      batchEntry: "Batch render",
      batchViewResults: "View render results",
      batchFromCameras: "Render from {count} cameras",
      batchTitle: "Batch render",
      batchNew: "New render",
      batchHistoryEmpty: "No renders yet. Start one from the camera panel on the right.",
      batchFailedUnknown: "Render failed; no reason was returned. Please retry.",
      batchFailedTimeout: "Render timed out. Please retry.",
      batchCaptureBusy: "The previous capture has not finished. Please wait.",
      batchPreviousResult: "Previous round",
      batchCameraNoResult: "No results yet",
      batchCameraRemoved: "Camera removed; its results are kept",
      batchRowSatisfied: "Target met — not generated this round",
      batchStepConfig: "Configure",
      batchStepCapture: "Confirm shots",
      batchCaptureConfirm: "Review the framing of each camera; recapture if adjustment is needed.",
      batchCaptureZoom: "Click to view full size",
      batchRecapture: "Recapture",
      batchCaptureNext: "Continue with {count} images",
      batchCaptureAllFailed: "All captures failed. Adjust the camera positions and try again.",
      batchStepRender: "Render",
      batchTarget: "Target images per camera",
      batchStyle: "Style",
      batchStylized: "Look",
      batchResolution: "Resolution",
      batchPromptPlaceholder: "Extra instructions (optional)",
      batchStartFailed: "Failed to start the render. Please try again later.",
      batchGenerate: "Generate {count} image(s)",
      batchAllSatisfied: "Every camera is satisfied — nothing to generate",
      batchNoCameras: "Place a camera on the floor plan first",
      batchAdopt: "Adopt",
      batchAdopted: "Adopted {n}/{k}",
      batchSatisfied: "Satisfied {k}/{k}",
      batchStale: "Camera {index} has moved; its {n} previously adopted image(s) no longer count",
      batchCapturing: "Capturing {i}/{n}",
      batchSubmitting: "Submitting {i}/{n} — please stay on this page",
      batchQueued: "Queued",
      batchPendingCapture: "Awaiting capture",
      batchCaptured: "Captured, not submitted",
      batchRunning: "Generating",
      batchDone: "Done",
      batchFailed: "Failed",
      batchRetry: "Retry",
      batchSkip: "Skipped",
      batchUnsupported: "The backend cannot generate {n} images at once yet — upgrade the api service first",
      batchInvalid: "Unavailable",
      batchClose: "Close",
    },
    editorToolSections: {
      stair: 'Stairs',
      accessory: 'Accessories',
      material: 'Materials',
      furniture: 'Furniture',
      lighting: 'Lighting',
      builtin: 'Built-in',
      appliance: 'Appliances',
      equipment: 'Equipment'
    },
    editorToolCategories: {
      stairStairs: 'Stairs',
      accessoryClocks: 'Clocks',
      accessoryMirrors: 'Mirrors',
      accessoryCushions: 'Cushions',
      accessoryArt: 'Art & wall decor',
      accessoryPlants: 'Plants',
      accessoryOther: 'Other',
      furnitureDiningTables: 'Dining tables',
      furnitureDesks: 'Desks',
      furnitureDoubleBeds: 'Double beds',
      furnitureSingleBeds: 'Single beds',
      furnitureRugs: 'Rugs',
      furnitureOther: 'Other',
      lightingPendant: 'Pendant lights',
      lightingDown: 'Downlights',
      lightingSpot: 'Spotlights',
      lightingStand: 'Floor & table lamps',
      lightingBracket: 'Wall lights',
      lightingOther: 'Other',
      builtinCounter: 'Counters',
      builtinShelf: 'Shelves',
      builtinPillowShelf: 'Headboard shelves',
      builtinStorage: 'Storage',
      builtinEntranceStorage: 'Entrance storage',
      builtinOther: 'Other',
      applianceRefrigerator: 'Refrigerators',
      applianceTv: 'TVs',
      applianceWasher: 'Washing machines',
      applianceDryer: 'Dryers',
      applianceMicrowave: 'Microwaves',
      applianceVacuum: 'Vacuums',
      applianceOther: 'Other',
      equipmentKitchen: 'Kitchens',
      equipmentCupboard: 'Cupboards',
      equipmentToilet: 'Toilets',
      equipmentWashbasin: 'Washbasins',
      equipmentBathtub: 'Bathtubs',
      equipmentWasher: 'Washing machines',
      equipmentWaterHeater: 'Water heaters',
      equipmentAirConditioner: 'Air conditioners',
      equipmentSwitch: 'Switches',
      equipmentOther: 'Other',
      furnitureKitchen: 'Kitchens',
      furnitureToilet: 'Toilets',
      furnitureBathroom: 'Bathrooms',
      furnitureWashbasins: 'Washbasins',
      furnitureAppliances: 'Appliances',
      furnitureAirConditioning: 'Air conditioning',
      furnitureWaterHeating: 'Water heating',
      walls: 'Walls',
      doorWindow: 'Doors / windows',
      holes: 'Openings',
      structure: 'Structure',
      stairs: 'Stairs',
      furniture: 'Furniture',
      kitchenBath: 'Kitchen / bath',
      furnitureSofa: 'Sofas',
      furnitureTables: 'Tables / desks',
      furnitureChairs: 'Chairs / stools',
      furnitureTableSets: 'Table sets',
      furnitureBeds: 'Beds',
      furnitureCabinets: 'Storage',
      furnitureStorage: 'Storage',
      furnitureLighting: 'Lighting',
      furnitureCushions: 'Cushions',
      furnitureClocks: 'Clocks',
      furnitureArtDecor: 'Art & Decor',
      furnitureMirrors: 'Mirrors',
      materialWallpaper: 'Wall material',
      materialFlooring: 'Flooring',
      other: 'Other',
      kitchenBathCabinet: 'Cabinets',
      kitchenBathKitchen: 'Kitchen',
      kitchenBathEquipment: 'Equipment',
      kitchenBathVanity: 'Bathroom vanity',
      kitchenBathSanitary: 'Sanitary'
    },
    editorToolRequired: {
      wall: 'Wall',
      area: 'Room area',
      door: 'Door',
      doorDouble: 'Double door',
      slidingDoor: 'Sliding door',
      window: 'Window',
      sashWindow: 'Sash window',
      gate: 'Gate',
      floorOpening: 'Floor opening',
      column: 'Column',
      columnSquare: 'Square column',
      beam: 'Beam',
      simpleStair: 'Simple stair',
      sofa: 'Sofa',
      tables: 'Tables / coffee tables',
      chairs: 'Stools / chairs',
      tableSets: 'Table sets',
      beds: 'Beds / bed sets',
      cabinets: 'Cabinets / shelves',
      kitchenCabinet: 'Kitchen cabinet',
      kitchen: 'Kitchen',
      equipment: 'Equipment',
      bathroomVanity: 'Bathroom vanity',
      sanitary: 'Sanitary'
    },
    editorToolUnavailable: 'Not available',
    editorProperty: {
      emptyTitle: 'Nothing selected',
      emptyHint: 'Select a wall, opening or furniture to edit it here.'
    },
    wallSurfaceMaterial: {
      title: 'Wall material',
      currentSide: 'Wall material · {side}',
      sideA: 'A · Left along wall direction',
      sideB: 'B · Right along wall direction',
      heading: 'Wall material',
      sideAShort: 'Side A',
      sideBShort: 'Side B',
      sideGroup: 'Wall side',
      texture: 'Texture',
      color: 'Color',
      source: 'Source',
      clearSide: 'Clear this side override',
      sources: { surface: 'Side override', legacy: 'Wall property', theme: 'Theme default' },
      textures: { bricks: 'Brick', painted: 'Painted wall' }
    },
    property: {
      clampedTo: 'Value adjusted to range {min}-{max}, applied value is {actual}',
      fittedToWall: 'Adjusted to {actual} to fit the wall'
    },
    editorBottom: {
      otherFloorOpacity: 'Other floors opacity',
      showOtherFloors: 'Show other floors',
      hideOtherFloors: 'Hide other floors',
      expand3d: 'Expand',
      previewInCanvas: '3D preview is shown in the main canvas',
      statistics: 'Data statistics'
    },
    aiRoomDesign: {
      title: 'AI Room Design',
      open: 'AI Rooms',
      selectedProduct: 'Selected product',
      noProduct: 'No product selected',
      selectProduct: 'Select product',
      browseProducts: 'Browse products',
      layerCount: 'Floors',
      livingRoom: 'Living Room',
      diningRoom: 'Dining Room',
      masterRoom: 'Master Bedroom',
      secondRoom: 'Bedroom / Study',
      kitchen: 'Kitchen',
      bathroom: 'Bathroom',
      storage: 'Storage',
      staircase: 'Staircase',
      notice1: 'AI will reference these requirements, but the final room composition is determined by the algorithm',
      notice2: 'Generated layout will align to 455mm modular grid and remove existing doors and windows',
      elapsed: 'Elapsed',
      submit: 'Generate Room Layout',
      needAtLeastOneRoom: 'At least one room is required',
      successTitle: 'Room Layout Generated Successfully'
    },
    aiWindowDesign: {
      title: 'AI Door & Window Design',
      open: 'AI Doors/Windows',
      roomCount: 'Current Room Count',
      notice: 'Doors and windows will be generated for all walls, existing ones will be replaced',
      elapsed: 'Elapsed',
      submit: 'Generate Doors & Windows',
      successTitle: 'Doors & Windows Generated Successfully',
      successMessage: 'Generated {doorCount} doors and {windowCount} windows'
    },
    aiCandidatePreview: {
      previewTitle: 'AI Design Preview',
      currentScene: 'Current Design',
      candidateScene: 'AI Candidate Design',
      previewHint: 'Please compare both designs and confirm to apply',
      floorLabel: 'Floor',
      outlineDiffsTitle: 'Outline Differences',
      layer: 'Floor',
      beforeSize: 'Original Size',
      afterSize: 'AI Size',
      sizeChange: 'Size Change',
      areaCoverage: 'Coverage Area',
      areaChange: 'Area Change',
      applyRoomLabel: 'Apply AI Room Design',
      applyWindowLabel: 'Apply AI Door & Window Design'
    },
    reportCapture: {
      title: 'Confirm report images',
      stepFloors: '2D floor plans',
      stepViews: '3D views',
      floorsHint: 'Review the floor plan image for each floor. Images are captured automatically based on content.',
      viewsHint: 'Review the 3D view images. The current view is used as the main image.',
      noFloors: 'No floors available.',
      noContent: 'This floor has no content to display.',
      viewIdle: 'Not captured yet.',
      recapture: 'Recapture',
      capture: 'Capture',
      reframe: 'Select area',
      reframeCancel: 'Cancel selection',
      reframeHint: 'Drag on the preview to select the capture area.',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      confirm: 'Confirm',
      delete: 'Delete',
      next: 'Next: 3D views',
      done: 'Done',
      cancel: 'Cancel',
      confirmIncomplete: 'Confirm all floor plans and five 3D report images before finishing.',
      mainBadge: 'Main',
      captureFailed: 'Failed to capture the screenshot.',
      statusIdle: 'Not captured',
      statusCapturing: 'Capturing...',
      statusReady: 'Pending confirmation',
      statusConfirmed: 'Confirmed',
      statusError: 'Error',
      summary: 'Confirmed: floors {floors}/{floorTotal} · 3D {views}',
      storageTrimmed: 'Trimmed {count} extra 3D view image(s) to fit local storage.',
      viewNames: {
        main: 'Main view',
        current: 'Current view',
        front: 'Front',
        back: 'Back',
        left: 'Left',
        right: 'Right'
      }
    },
    reportAssetsMissing: {
      title: 'Report images not confirmed',
      message: 'This project has not confirmed floor plan and 3D report images yet. You can confirm the images first, or continue exporting with system-generated default assets.',
      confirmImages: 'Confirm images',
      useDefault: 'Continue with default assets',
      cancel: 'Cancel'
    },
    reportAssetDefault: {
      generateFailed: 'Failed to generate default report assets. Please try again later.',
      retry: 'Retry',
      missingFloorPlan: 'Missing floor plan image(s)',
      missing3dView: 'Missing 3D report image(s)',
      captureFailed: 'Failed to capture screenshot'
    },
    shareLink: {
      title: 'Share link',
      generating: 'Generating share link...',
      mockNotice: 'This is a demo link. Full sharing will be enabled after the backend API is connected.',
      copy: 'Copy link',
      copied: 'Copied',
      copyFailed: 'Copy failed. Please copy manually.',
      error: 'Failed to generate share link',
      retry: 'Retry',
      close: 'Close'
    },
    roomAreas: {
      dirtyHint: 'Room areas may have changed. Click "Re-detect room areas" to refresh areas and sizes.',
      recompute: 'Re-detect room areas',
      recomputeSuccess: 'Room areas re-detected',
      recomputeFailed: 'Room detection failed. Existing areas were kept.',
      recomputeHistory: 'Re-detect room areas',
      metricsSummary: '{roomCount} rooms · {totalAreaM2} m² total · {bedroomCount} bedrooms'
    },
    exportPdf: {
      success: 'PDF download started',
      failed: 'PDF export failed',
      mockNotice: 'This is a mock sample PDF. Production reports will ship in phase 2 backend export.',
      capturePartial: 'Some captures failed; export continued without blocking editing.'
    },
    exportHtml: {
      success: 'HTML report exported and opened in a new tab',
      failed: 'HTML export failed',
      mockNotice: 'This is a static mock HTML page. Hosted publishing arrives in phase 2.',
      capturePartial: 'Some captures failed; export continued without blocking editing.'
    },
    deleteSelected: 'Delete selected',
    applyToSelection: 'Apply to selection',
    moveSelected: 'Move selected',
    moveToFloor: 'Move to floor',
    visible: 'Visible',
    unchanged: 'unchanged',
    warnings: 'Warnings',
    errors: 'Errors',
    aiSubmitting: 'Submitting AI task...',
    aiProcessing: 'AI is processing · {seconds}s · poll {attempt}',
    aiTodo: 'TODO: AI service integration is intentionally disabled.',
    featureDeveloping: 'Feature is under development',
    savedLocally: 'Saved.',
    saveFailed: 'Your current changes were not saved.',
    draftRestored: 'Unsaved editing draft restored.',
    versionRestored: 'Local version restored.',
    projectLoaded: 'Project loaded.',
    invalidProjectJson: 'Invalid project JSON.',
    importDialogTitle: 'Import local JSON',
    importAsNewHint: 'This will be imported as a new project and will not affect the current project.',
    importStructureDecodeFailed: 'The structure data could not be decoded; only the building was imported.',
    importName: 'Project name',
    importBudget: 'Budget (10k JPY)',
    importFrontage: 'Frontage (ken)',
    importConfirm: 'Import as new project',
    importRequiredFields: 'Please fill in project name, budget and frontage before importing.',
    importedAsNewProject: 'Imported as a new project.',
    groups: 'Groups',
    floors: 'Floors',
    opacity: 'Opacity',
    currentFloor: 'Current floor',
    floorProperties: 'Floor properties',
    basicParams: 'Basic parameters',
    layoutOpacity: 'Display parameters',
    deleteFloor: 'Delete floor',
    deleteCurrentFloor: 'Delete current floor',
    deleteFloorConfirmMessage: 'Deleting this floor will remove all design content on it. Continue?',
    guides: 'Guides',
    newGroup: 'New group',
    addSelected: 'Add selected',
    groupName: 'Group name',
    rotate: 'Rotate',
    duplicate: 'Duplicate',
    ungroup: 'Ungroup',
    deleteAll: 'Delete all',
    removeFromGroup: 'Remove from group',
    addFloor: 'Add floor',
    addUpperFloor: 'Add upper floor',
    addLowerFloor: 'Add lower floor',
    deleteFloorButton: 'Delete current floor',
    floorInsertPosition: 'Insert position',
    floorPositionAbove: 'Above current floor',
    floorPositionBelow: 'Below current floor',
    floorName: 'Floor name',
    floorCustomNamePlaceholder: 'Enter floor name',
    copyStructure: 'Copy current floor plan structure',
    confirm: 'Confirm',
    duplicateFloor: 'Duplicate floor',
    selectAllFloor: 'All',
    selectAllFloorElements: 'Select all floor elements',
    lock: 'Lock',
    altitude: 'Altitude',
    floorHeight: 'Floor height',
    slabThickness: 'Slab thickness',
    moveUp: 'Move up',
    moveDown: 'Move down',
    addSelectedElement: 'Add selected element',
    noVersions: 'No manual save versions yet.',
    restore: 'Restore',
    localVersions: 'Local versions',
    sceneWidth: 'Scene width ({unit})',
    sceneHeight: 'Scene height ({unit})',
    name: 'Name',
    description: 'Description',
    unit: 'Unit',
    familySize: 'Family size',
    style: 'Style',
    budget: 'Budget',
    daylightPriority: 'Daylight priority',
    notes: 'Notes',
    roomRequirements: 'Room requirements',
    roomRelationships: 'Room relationships',
    fromRoom: 'From room',
    toRoom: 'To room',
    add: 'Add',
    aiServiceTodo: 'TODO: AI service',
    rooms: {
      living_room: 'Living room',
      bedroom: 'Bedroom',
      kitchen: 'Kitchen',
      bathroom: 'Bathroom',
      dining_room: 'Dining room'
    },
    styles: {
      modern: 'modern',
      minimal: 'minimal',
      classic: 'classic',
      industrial: 'industrial'
    },
    budgets: {
      economy: 'economy',
      standard: 'standard',
      premium: 'premium'
    },
    roomStatistics: {
      title: 'Room statistics',
      scope: 'Scope',
      allFloors: 'All floors',
      unnamedOrUnrecognized: 'Unnamed / unrecognized',
      roomType: 'Room type',
      roomCount: 'Count',
      totalRooms: 'Total rooms',
      totalArea: 'Total area',
      calculating: 'Calculating',
      refreshing: 'Updating',
      stale: 'Data may be out of date',
      recompute: 'Recalculate room areas',
       noData: 'No statistics available'
     },
     aiStructure: {
       entry: 'AI structure generation',
       modes: {
         label: 'Display mode',
         architecture: 'Architecture',
         structure: 'Structure'
       },
       overlay: {
         showBuilding: 'Show building overlay',
         hideBuilding: 'Hide building overlay',
         opacity: 'Building overlay opacity'
       },
       plans: {
         label: 'Structural plan',
         foundation: 'First-floor framing plan',
         'beam-column': '{floor} roof framing plan',
         'bearing-wall': '{floor} bearing wall layout plan'
       },
       lineModes: {
         label: 'Drawing mode',
         line: 'Line',
         fixedWidth: 'Fixed-width line',
         cappedLine: 'Capped line'
       },
       messages: {
         readOnly: 'This display mode is read-only.',
         applied: 'The structure proposal was applied.'
       },
       errors: {
         system: 'The structure data could not be retrieved. Please try again.',
         unavailable: 'The structure data is unavailable. Please generate it again.',
         readOnly: 'This display mode is read-only.'
       },
       properties: {
         title: 'Structure element properties',
         empty: 'Select a structure element to view read-only properties.',
         layer: 'Floor',
         type: 'Type',
         role: 'Role',
         section: 'Section',
         elevation: 'Elevation',
         hostWall: 'Host wall',
         wallSpecification: 'Wall specification'
       }
     },
     mechanicsCheck: {
       historyUnlinked: "Historical checks have no structure link. Run a new check to associate the result.",
       runningPrevious: "A new check is running. Showing the previous completed result.",
       latestFailedPrevious: "The latest check failed. Showing the previous completed result.",
       recoveryFailed: "Could not load the cloud check result. Refresh to retry.",
       recoveryUnlinked: "This structure has no verifiable task link. Generate the structure again before checking.",
       showFailures: 'Show failed members',
       hideFailures: 'Hide highlighting',
       detailTitle: 'Member failure details',
       detailEmpty: 'No details were provided in the check result.',
       entry: 'Structural mechanics check',
       requiresStructure: 'Generate the AI structure first.',
       started: 'The structural mechanics check has started.',
       completed: 'The structural mechanics check is complete.',
       failed: 'The structural mechanics check failed. Please try again.',
       resultTitle: 'Mechanics check result',
       resultLoading: 'Running the structural mechanics check…',
       resultPreparing: 'Loading the mechanics check result…',
       resultPreparingDescription: 'The calculation is complete. Result files are being loaded.',
       resultEmpty: 'No structural mechanics check has been run.',
       statusDescription: 'Waiting for the check result. The current structure remains visible.'
     }
   },
  designEvaluation: {
    entry: 'Design Review',
    dialogTitle: 'Design Review',
    planPreviewLabel: 'Floor plan',
    previewLoading: 'Generating floor plan',
    previewFailed: 'Failed to generate this floor plan',
    retryPreview: 'Retry',
    designNotReady: 'Please complete the AI design first',
    backendUnavailable: 'Design review is currently unavailable',
    scoreLabel: 'Score',
    scoreRequired: 'Please select a score from 1–10',
    scoreAriaHint: 'Score from 1 to 10',
    commentLabel: 'Comments',
    commentPlaceholder: 'Enter your review',
    commentCounter: '{count} / 1000',
    submissionNotice: 'Floor plans are for confirmation only; submission includes only the design ID, score, and comments',
    submit: 'Submit review',
    cancel: 'Cancel',
    submitting: 'Submitting',
    successMsg: 'Review recorded',
    errorScore: 'Invalid score, please select an integer from 1–10',
    errorCommentTooLong: 'Comments exceed 1000 characters',
    errorForbidden: 'This account does not have permission to submit reviews',
    errorNotFound: 'Design does not exist or is inaccessible',
    errorNotReady: 'AI design is not yet complete',
    errorRateLimited: 'Too many submissions, please try again later',
    errorInternal: 'Submission failed, please try again later',
    errorGeneric: 'Submission failed'
  },
  floorplan: {
    categories: {
      lines: 'Walls',
      holes: 'Doors / Windows',
      structure: 'Structure',
      furnishings: 'Furnishings',
      items: 'Items',
      areas: 'Areas'
    },
    elements: {
      wall: 'Wall',
      "door": "Single hinged door",
      "door-double": "Double hinged door",
      "door-parent-child": "Unequal double door",
      "sliding-door": "Double sliding door",
      "door-pocket": "In-wall sliding door",
      "door-surface-sliding": "Surface sliding door",
      "door-folding": "Folding door",
      "window": "Sliding window",
      "window-fixed": "Fixed window",
      "window-side-hung": "Side-hung window",
      "window-casement": "Side-projecting window",
      "window-awning": "Top-hung window",
      split: 'Opening',
      sofa: 'Sofa',
      bed: 'Bed',
      chair: 'Chair',
      bench: 'Bench',
      'dining-table': 'Dining Table',
      'round-table': 'Round Table',
      'low-table': 'Low Table',
      desk: 'Desk',
      'side-table': 'Side Table',
      console: 'Console',
      shelf: 'Shelf',
      cabinet: 'Cabinet',
      'clothes-rack': 'Clothes Rack',
      'tv-board': 'TV Board',
      refrigerator: 'Refrigerator',
      kitchen: 'Kitchen Counter',
      toilet: 'Toilet',
      bathtub: 'Bathtub',
      washbasin: 'Washbasin',
      'washing-machine': 'Washing Machine',
      'shoe-cabinet': 'Shoe Cabinet',
      stair: 'Stairs',
      'sofa-B': 'Sofa B',
      'chair-A': 'Chair A',
      'chair-B': 'Chair B',
      column: 'Column',
      beam: 'Beam',
      'floor-opening': 'Floor Opening',
      'ceiling-opening': 'Ceiling Void',
      'ceiling-drop': 'Dropped Ceiling',
      'column-square': 'Square Column',
      'independent-column': 'Independent Column',
      'fridge-A': 'Fridge A',
      'simple-stair': 'Straight Stair',
      'stair-l': 'L-shaped Stair',
      'stair-u': 'U-shaped Stair',
      'stair-c': 'Three-flight Stair',
      'tv-board-A': 'TV Board A',
      'tv-board-B': 'TV Board B',
      area: 'Room Area'
    },
    attributes: {
      name: 'Name',
      visible: 'Visible',
      x: 'X',
      y: 'Y',
      rotation: 'Angle',
      offset: 'Position',
      catalogItemId: 'Catalog item',
      modelId: 'Model ID',
      textureId: 'Texture ID',
      materialId: 'Material ID',
      displayName: 'Display name',
      computedAreaM2: 'Area (m²)',
      computedAreaTsubo: 'Area (tsubo)'
    },
    properties: {
      type: "Form",
      hinge: "Hinge / sliding side",
      swing: "Swing",
      registeredSize: "Registered size",
      foldingPanels: "Panels",
      handleStyle: "Handle",
      finish: 'Finish',
      beamDepth: 'Beam Depth',
      dropDepth: 'Drop',
      openingWidth: "Opening width",
      storageSide: "Storage side",
      mountSide: "Mount side",
      pocketSlotSide: "Pocket side",

      size: 'Size',
      basicParams: 'Basic Parameters',
      dimensionParams: 'Dimensions',
      roomName: 'Room Name',
      sizeVariant: 'Size option',
      selectedMaterial: 'Selected',
      searchMaterial: 'Filter by name',
      noMaterialMatch: 'No matching materials',
      manufacturer: 'Brand',
      width: 'Width',
      depth: 'Depth',
      height: 'Height',
      length: 'Length',
      thickness: 'Thickness',
      floorDistance: 'Floor distance',
      topHeight: 'Top height',
      lighting: 'Lighting',
      lightOnEvening: 'Light up from the evening',
      floorElevation: 'Floor offset',
      elevation: 'Elevation',
      color: 'Color',
      material: 'Material',
      texture: 'Texture',
      texturePreview: 'Texture Preview',
      rotation: 'Angle',
      offset: 'Position',
      open: 'Open',
      flip_orizzontal: 'Flip',
      position: 'Position'
    },
    beamFinishes: {
      wood: 'Wood (exposed beam)',
      wallpaper: 'Wallpaper (boxed beam)'
    },
    handleStyles: {
      lever: "Lever",
      knob: "Knob",
      pull: "Pull",
      bar: "Bar",
      recessed: "Recessed pull",
      none: "None"
    },
    fittingOptions: {
      panelCount: '{n} panels',
      left: "Left",
      right: "Right",
      in: "Inward",
      out: "Outward",
      storageLeft: "Store left",
      storageRight: "Store right",
      mountIn: "Inside face",
      mountOut: "Outside face",
      slotIn: "Inner side",
      slotOut: "Outer side"
    },
    textures: {
      plain: 'Solid color',
      default: 'Not set',
      bricks: 'Bricks',
      painted: 'Painted',
      wood: 'Wood',
      tile: 'Tile',
      tatami: 'Tatami',
      concrete: 'Concrete',
      none: 'None'
    },
    materials: {
      fabric: 'Fabric',
      wood: 'Wood',
      metal: 'Metal',
      glass: 'Glass',
      plastic: 'Plastic'
    }
  },
  errors: {
    sessionExpired: 'Session expired. Please sign in again.',
    requestFailed: 'Request failed',
    aiDesignNetworkError: 'Network error, please check your connection',
    aiDesignTimeout: 'Design timeout, please try again later',
    aiDesignServiceError: 'Service temporarily unavailable',
    aiDesignValidationError: 'Input validation failed',
    aiDesignPartitionFailed: 'Cannot generate initial rooms from current outline, please adjust the outline and try again',
    aiDesignOutlineShrunk: 'AI returned building range smaller than original outline, result discarded',
    aiDesignParseError: 'Result format error',
    aiDesign: {
      VALIDATION_ERROR: 'Input validation failed',
      NETWORK_ERROR: 'Network connection failed',
      TIMEOUT: 'Service execution timeout',
      REMOTE_SERVICE_ERROR: 'AI service returned error',
      PARSE_ERROR: 'Unable to parse download package or JSON',
      PARTITION_FAILED: 'Current wall layout cannot form complete AI input',
      OUTLINE_SHRUNK: 'Building outline has changed',
      AI_RESULT_INVALID: 'AI returned invalid structure',
      AI_RESULT_STATS_MISMATCH: 'Backend statistics inconsistent with actual doors/windows',
      AI_ELEMENT_GEOMETRY_CHANGED: 'Door/window phase modified walls or rooms',
      AI_SOURCE_SCENE_CHANGED: 'Floor plan has changed, candidate is stale',
      APPLY_FAILED: 'Failed to apply AI design',
      UNKNOWN: 'Unknown error'
    }
  },
  reportStudio: {
    entry: 'Image Studio',
    back: 'Back to editor',
    save: 'Save',
    saveSuccess: 'Report assets saved',
    saveFailed: 'Failed to save report assets. Please try again.',
    saveStatusUnsaved: 'Unsaved',
    saveStatusSaved: 'Saved',
    canvasPlaceholder: '{type} — coming soon',
    settingsPlaceholder: 'Settings panel (coming soon)',
    assetRailPlaceholder: 'Asset rail (coming soon)',
    types: {
      layout: 'Layout',
      floorPlan: 'Floor plan',
      render: '3D render',
      elevation: 'Elevation'
    },
    rail: {
      title: 'Saved assets',
      empty: 'No saved assets for this type',
      delete: 'Delete',
      confirmForReport: 'Confirm for PDF/HTML report',
      confirmedForReport: 'Confirmed for PDF/HTML',
      statusPreview: 'Preview not confirmed',
      statusMissing: 'Missing / pending',
      slots: {
        layout: 'Layout',
        floorPlan: 'Floor {layer}',
        renderMain: 'Main view',
        renderSubTop: 'Sub (top)',
        renderSubBottom: 'Sub (bottom)',
        elevationFront: 'Front',
        elevationBack: 'Back',
        elevationLeft: 'Left',
        elevationRight: 'Right'
      }
    },
    render: {
      renderType: 'Render type',
      renderTypeScreenshot: 'Current screenshot',
      aiRender: 'AI render',
      aiRenderPending: 'API pending integration',
      cameraPresets: 'Camera presets',
      presets: {
        'oblique-front': 'Oblique front',
        aerial: 'Aerial'
      },
      renderStyle: 'Render style',
      renderStylePlaceholder: 'Coming soon',
      aspectRatio: 'Aspect ratio',
      aspectRatioPlaceholder: 'Coming soon',
      saveCurrentView: 'Save current view',
      saveAsMain: 'Save as main',
      saveAsSubTop: 'Save as sub (top)',
      saveAsSubBottom: 'Save as sub (bottom)',
      resetCamera: 'Reset camera',
      captureFailed: '3D capture failed'
    },
    elevation: {
      direction: 'Direction',
      directions: {
        front: 'Front',
        back: 'Back',
        left: 'Left',
        right: 'Right'
      },
      layoutMode: 'Layout mode',
      layoutModeSingle: 'Single view',
      layoutModeOverview: 'Four-view overview',
      saveCurrentView: 'Save orthographic view',
      saveDirection: 'Save {direction}',
      unsaved: 'Not saved',
      backToOverview: 'Back to overview',
      resetCamera: 'Reset camera',
      captureFailed: '3D capture failed',
      generateSingleViewPreview: 'Generate single-view preview'
    },
    confirm: {
      replaceTitle: 'Replace confirmed image',
      replaceMessage: 'This asset is confirmed for the PDF/HTML report. Replace it with a new image?',
      deleteTitle: 'Delete report asset',
      deleteMessage: 'The report will be missing this asset after deletion. Continue?',
      noPreview: 'Generate or select an image on the left first',
      confirmButton: 'Confirm'
    },
    capture: {
      deprecatedGuard: 'This dialog is no longer on the production export path. Confirm assets in the report studio before exporting.'
    },
    layout: {
      imageSource: 'Image source',
      upload: 'Upload image',
      pickExisting: 'Pick from existing',
      pickEmpty: 'No images available to pick',
      fitMode: 'Fit mode',
      fitWidth: 'Fit width',
      fitHeight: 'Fit height',
      fitPage: 'Fit page',
      saveLayout: 'Save layout image',
      noImageSelected: 'Upload or pick an image first',
      canvasEmpty: 'Blank page preview (no image selected)',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      uploadFailed: 'Failed to read image',
      uploadInvalidType: 'Please select an image file'
    },
    floorPlan: {
      floorSwitch: 'Floor',
      visibility: 'Visibility',
      showTotalDimensions: 'Overall dimensions',
      showSegmentDimensions: 'Segment dimensions',
      showRoomNames: 'Room names',
      showRoomAreas: 'Room areas',
      showFurniture: 'Furniture',
      showHoles: 'Doors & windows',
      dimensionActions: 'Dimension tools',
      autoGenerate: 'Auto generate',
      addManual: 'Add manual',
      cancelManualAdd: 'Cancel add',
      deleteSelected: 'Delete selected',
      hideSelected: 'Hide selected',
      regenerateAll: 'Regenerate all',
      resetOffsets: 'Reset offsets',
      roomLabelActions: 'Room labels',
      toggleRoomLabels: 'Toggle labels',
      resetRoomLabelPositions: 'Reset positions',
      saveCurrentFloor: 'Save current floor as report asset',
      captureFailed: '2D capture failed',
      noChainSelected: 'Select a dimension chain first',
      manualAddHint: 'Click two points on the canvas in order',
      manualAddInvalid: 'Only horizontal/vertical dimensions are supported',
      noDimensionBounds: 'The current floor has no outline for dimension generation'
    }
  },
  reportExportConfirm: {
    title: {
      pdf: 'PDF report export confirmation',
      html: 'HTML report export confirmation'
    },
    generatePdf: 'Generate PDF report',
    generateHtml: 'Generate HTML report',
    optionalBadge: 'Optional',
    missingHint: '{count} required asset(s) are missing or pending confirmation. Complete them before generating.',
    optionalMissingHint: 'Layout image is optional; missing it does not block report generation.',
    openStudioHint: 'Click to open studio and confirm',
    statusConfirmed: 'Confirmed',
    statusPreview: 'Pending',
    statusMissing: 'Missing / pending'
  },
  // P06: async AI design UI copy (align P01–P05/P07; distinct from errors.aiDesign)
  aiDesign: {
    fields: {
      productType: 'ProductType (project name)',
      totalArea: 'TotalArea (tsubo)',
      layers: 'Layers (floors)',
      widthKen: 'WidthKen (frontage)',
      unitPrice: 'Unit price per tsubo',
      unitPriceValue: '{count} man-yen / tsubo',
      totalAreaValue: '{count} tsubo',
      budget: 'Budget',
      frontage: 'Frontage',
      projectName: 'Project name',
      algorithm: 'Algorithm'
    },
    algorithms: {
      floorplan_diffusion: 'Diffusion Model',
      floorplan_gpt_image_2: 'VLM',
      floorplan_gpt6: 'LLM Agent',
      building_element_diffusion: 'Openings Diffusion',
      building_element_rule: 'Openings Rule'
    },
    status: {
      queued: 'Queued',
      generating: 'Generating',
      completed: 'Completed',
      failed: 'Generation failed',
      waitedTime: 'Waited {seconds} s',
      canLeavePage: 'You can leave this page'
    },
    actions: {
      abandonTask: 'Abandon task',
      abandonConfirm: 'Abandon task "{name}"? Results will no longer be shown or applied.',
      viewNewPlan: 'View new plan',
      confirmReplace: 'Confirm replace',
      retrySameParams: 'Retry with original parameters'
    },
    waiting: {
      editLocked: 'Editing is locked during generation. The task continues in the background; you can leave this page and return later.',
    },
    messages: {
      floorplanChanged: 'The current floor plan has changed',
      regenerateWindows: 'Please regenerate doors and windows',
      busy: 'The service is busy. Please try again later.',
      taskRecordCorrupted: 'Task record is corrupted',
      resultInvalid: 'Result is invalid'
    },
    projectCard: {
      generating: 'Generating',
      completed: 'Completed',
      failed: 'Failed'
    },
    validation: {
      budget: 'Budget must be an integer from 500 to 3500 (man-yen)',
      input: 'Invalid input',
      projectName: 'Please enter a project name',
      frontage: 'Frontage must be 2–5 ken in 0.5 steps',
      layers: 'Layers must be 1–3',
      algorithm: 'The selected algorithm is not allowed for this design type'
    }
  },
  drawingVectorize: {
    editor: {
      loadFailed: 'Could not load the calibrated drawing. Please try again.',
      rescale: 'Scale',
      autosaveOn: 'Autosave',
      autosaveSaving: 'Saving…',
      autosaveSaved: 'Saved',
      autosaveFailed: 'Save failed',
      furnitureArriving: 'Placing furniture…',
      furnitureFailed: 'Furniture could not be read. You can still edit the rooms',
      reupload: 'Regenerate',
      reuploadConfirm: 'Go back to the upload screen.'
    },
    rescale: {
      title: 'Change scale',
      gridTitle: 'Small grid',
      gridHint: 'Grid size the walls snap to.',
      warning: 'Changing the scale discards your edits in the editor.',
      apply: 'Rebuild at this scale',
      confirm: 'Rebuild with this scale?',
      done: 'Scale changed'
    },
    upload: {
      title: 'Import from drawing',
      handDrawnTitle: 'Upload hand-drawn floor plan',
      subtitle: 'Upload a floor plan and we detect walls, openings and rooms. If the drawing has dimensions, the scale is set from them automatically; otherwise click a wall whose real length you know and enter it to lock the scale.',
      dropTitle: 'Upload drawing',
      dropMain: 'Drop your floor plan here',
      dropSub: 'Drag and drop an image or document, or click this area to choose a file',
      page: 'PDF page',
      pdfSelectTitle: 'Select the page to recognize',
      pdfLoading: 'Loading PDF pages...',
      pdfFailed: 'This PDF could not be previewed. Enter the page number instead.',
      pdfPageLabel: 'Page {page}',
      pdfPageCount: '{count} pages',
      pdfTooManyPages: 'Showing the first {max} pages only.',
      accepted: 'PNG / JPEG / TIFF / PDF, up to 5MB',
      tooLarge: 'File exceeds 5MB',
      start: 'Start recognition',
      cancel: 'Cancel',
      stopWaiting: 'Stop waiting',
      retry: 'Retry',
      detail: 'Details',
      projectName: 'Project name',
      apply: 'Open in editor',
      reupload: 'Upload another drawing',
      backToEditor: 'Back to editor',
      sourceTitle: 'Uploaded drawing',
      sourceOpen: 'Click to enlarge',
      sourceClose: 'Close',
      removeFile: 'Remove the uploaded drawing',
      regionHint: 'Drag the frame to choose the area to read.',
      regionReset: 'Reset to the whole page',
      reading: 'Reading the drawing…',
      restoring: 'Loading the last drawing…',
      restoreFailed: 'The last drawing could not be loaded. Please upload it again.',
      sourceNoPreview: 'PDF cannot be previewed here.'
    },
    progress: {
      uploading: 'Uploading the drawing',
      queued: 'Queued, waiting to start',
      recognizing: 'Recognizing',
      backgroundNotice: 'Recognition keeps running after you leave this page.'
    },
    calibrate: {
      title: 'Scale calibration',
      badgeCalibrated: 'Calibrated',
      badgeUncalibrated: 'Not calibrated',
      assumedNotice: 'Enter the correct dimension',
      pickPrompt: 'Click a wall whose real length you know.',
      wholeWall: 'Center-to-center',
      wholeWallUnavailable: 'This segment has no source wall on record, so only the single segment is measured.',
      currentLength: 'Current length',
      currentLengthValue: 'about {mm} mm ({px} px)',
      inputPlaceholder: 'Real length in millimetres',
      submit: 'Calibrate',
      submitting: 'Calculating…',
      result: '{mmPerPx} mm/px / reference: {reference}',
      badgeAuto: 'Automatic',
      badgeSuggested: 'Please check',
      autoTitle: 'The scale was set automatically from the dimensions on the drawing.',
      suggestedTitle: 'The scale was estimated from the dimensions on the drawing. Please check it before confirming.',
      reasons: {
        single_orientation: 'Only horizontal or only vertical dimensions could be read.',
        orientation_disagree: 'The horizontal and vertical dimensions give different scales.',
        no_long_baseline: 'No dimension spanning the whole building could be read.',
        few_inliers: 'Too few dimensions agree with each other.',
        low_agreement: 'The dimensions read disagree too much with each other.'
      },
      extentValue: 'Building outline: about {width} m × {height} m',
      acceptEstimate: 'Use this scale',
      pickPromptOverride: 'If it is wrong, click a wall whose real length you know and enter its length.',
      overridden: 'Changed from the scale set automatically from the drawing dimensions ({mmPerPx} mm/px).',
      revertToEstimate: 'Revert to automatic',
      referenceDimensions: 'drawing dimensions'
    },
    quality: {
      title: 'Worth reviewing',
      adjustment: 'Adjustment "{action}": {count}',
      // 楼梯识别的调整记录。没有对应文案的动作码仍原样显示（见 WizardImportDrawingView）。
      actions: {
        area_relabelled_staircase: 'Room changed to a stairwell because a stair is drawn in it',
        stair_synthesized_from_area: 'Stair placed automatically in the stairwell (stair itself not detected)',
        stair_form_inferred: 'Stair form guessed from the room shape',
        stair_direction_inferred: 'Stair up-direction guessed',
        stair_facing_conflicts_footprint: 'Up-direction contradicted the footprint; orientation changed',
        stair_form_conflicts_footprint: 'Stair form contradicted the footprint; guessed from the room shape',
        stair_area_not_rectangular: 'Stairwell is not rectangular',
        stair_footprint_fallback_to_preset: 'Standard stair size used; room did not fit',
        stair_footprint_from_detection: 'Room has a missing corner; stair footprint taken from the detected box (stair over under-stair storage)',
        stair_footprint_from_room_label: 'Stair footprint taken from the room label box (detected box too small)',
        stair_clamped_to_min_footprint: 'Room too small; minimum stair size used',
        stair_overflows_area: 'Stair extends beyond its room',
        stair_without_area: 'Stair detected outside any room',
        stair_dropped_at_placement: 'Stair could not be placed',
        staircase_area_without_stair: 'Stairwell too large or too small; no stair placed',
        staircase_label_ignored: 'Large room labelled only UP / DN not treated as a stairwell',
        stair_opening_added: 'Opening added in the wall at the stair entrance (from the stair direction)',
        stair_opening_skipped_exterior: 'Stair entrance faces an exterior wall; no opening added (check the stair direction)',
        stair_opening_skipped_room: 'Stair entrance faces a bathroom, storage or bedroom; no opening added (check the stair direction)',
        stair_opening_skipped_narrow: 'Wall at the stair entrance too short for an opening',
        stair_orientation_from_start: 'Stair orientation corrected from the start of the walking line (UP / DN start)',
        stair_direction_from_neighbour: 'Stair direction inferred from the room outside its entrance',
        furniture_outside_building_dropped: 'Removed furniture far from the building (usually picked up from a rendering on the same page)',
        floor_level_from_drawing: 'Floor steps set from the floor levels written on the drawing (1FL-200, +300, etc.)',
        floor_level_assumed_from_name: 'Skip floor / raised nook heights set to default values (no height on the drawing, please check them in the editor)',
        floor_boundaries_split_rooms: 'Rooms split along floor steps and handrails (not walls)',
        stair_room_carved: 'The stair shared a space with the next room and was cut out as its own room',
        column_dropped: 'Column candidates not placed (wrong size, inside a wall or furniture)'
      },
      unmatchedRooms: 'Rooms not matched to a face: {names}',
      reviewRequired: 'A manual review is recommended overall.',
      adviceOnly: 'You can fix these in the editor.'
    },
    errors: {
      DRAWING_VECTORIZE_BUSY: 'The recognition service is busy. Retry in about {seconds}s.',
      DRAWING_VECTORIZE_FAILED: 'Recognition failed. Please try again later.',
      DRAWING_INPUT_UNSUPPORTED: 'Unsupported file. Choose PNG / JPEG / TIFF / PDF up to 5MB.',
      DRAWING_CALIBRATION_INVALID: 'That length cannot calibrate the scale. Try another wall or check the real size.',
      DRAWING_SCENE_REJECTED: 'The recognized result could not be loaded into the editor.',
      TIMEOUT: 'The request timed out. Please retry.',
      NETWORK_ERROR: 'Network unreachable.',
      REMOTE_SERVICE_ERROR: 'The service returned an error.',
      VALIDATION_ERROR: 'Please check your input.',
      STORAGE_WRITE_FAILED: 'Saving failed.',
      NAME_REQUIRED: 'Please enter a project name.',
      NOT_CALIBRATED: 'The scale is not calibrated. Enter a real length first.',
      IMPORT_FAILED: 'Could not create the project.',
      DRAWING_JOB_SUBMIT_FAILED: 'Could not submit the recognition job. Please try again.',
      DRAWING_JOB_NOT_FOUND: 'That recognition job no longer exists. Please start a new one.',
      DRAWING_JOB_FAILED: 'The recognition job failed. Please try again.',
      DRAWING_JOB_TIMEOUT: 'Timed out waiting for recognition. The job may still be running — try again shortly.',
      DRAWING_RESULT_NOT_READY: 'The result is not ready yet. Please wait a moment.',
      UNKNOWN: 'An unknown error occurred.'
    }
  },
  el: elementLocale.el
}
